import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';


// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/angle-double-left.json)
const angleDoubleLeftIconData = {
	icon: {
		attrs: [],
		colorPermutations: {
			'10210410212831741': [],
			'11331341331': [],
			'12402402401': [],
		},
		grid: 14,
		paths: [
			'M447.4 478l272-272c18.8-18.8 49.2-18.8 67.8 0l45.2 45.2c18.8 18.8 18.8 49.2 0 67.8l-192.6 193 192.8 192.8c18.8 18.8 18.8 49.2 0 67.8l-45.2 45.4c-18.8 18.8-49.2 18.8-67.8 0l-272-272c-19-18.8-19-49.2-0.2-68zM63.4 546l272 272c18.8 18.8 49.2 18.8 67.8 0l45.2-45.2c18.8-18.8 18.8-49.2 0-67.8l-192.6-193 192.8-192.8c18.8-18.8 18.8-49.2 0-67.8l-45.2-45.4c-18.8-18.8-49.2-18.8-67.8 0l-272 272c-19 18.8-19 49.2-0.2 68z',
		],
		tags: ['angle-double-left'],
		width: 896,
	},
	attrs: [],
	properties: {
		code: 59703,
		id: 767,
		name: 'angle-double-left',
		order: 2496,
		prevSize: 20,
	},
	setIdx: 1,
	setId: 1,
	iconIdx: 70,
};

// Create IconBuilder from cond-ui-kit data
const AngleDoubleLeftIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	angleDoubleLeftIconData as any,
	'#89c32e', // Default green color for new navigation
);

export default AngleDoubleLeftIconBuilder;
